import { Divider, Grid } from "@material-ui/core";
import React from "react";
import { BackButton } from "../../buttons";
import AddressData from "./address";
import { default as BasicData } from "./basic";
import CompanyPartnerData from "./companyPartner";
import ContactData from "./contact";
import IncomeData from "./income";
import ModelData from "./model";

const PessoaData = ({ assertiva, onClickBack, data }) => {
  const {
    dadosPessoais,
    pessoas,
    enderecos,
    emails,
    telefones,
    historicoProfissional,
    participacoesEmpresas,
  } = assertiva || {};

  return (
    <>
      <BasicData data={data} assertiva={dadosPessoais} />
      <ModelData data={data} />

      {!pessoas && (
        <>
          {assertiva && !data.pessoa.cpfCnpj && (
            <Grid container>
              <Divider className="mt-20 mb-20 w-100" />

              <BackButton
                backToTable={onClickBack}
                text="VOLTAR PARA TABELA DE HOMÔNIMOS"
              />
            </Grid>
          )}

          <AddressData data={enderecos} />
          <ContactData data={{ emails: emails, phones: telefones }} />
          <IncomeData data={historicoProfissional} />
          <CompanyPartnerData data={participacoesEmpresas} />
        </>
      )}
    </>
  );
};

export default PessoaData;
